<kendo-dialog-titlebar>
    {{'shared.header.chooseDate' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">
        <date-time-input-ctrl *ngIf="!dateOnly" [settings]="{fxFill:true}" [caption]="label | translate"
        [formControlName]="'selectedDate'"></date-time-input-ctrl>

        <date-input-ctrl *ngIf="dateOnly" [settings]="{fxFill:true}" [caption]="label | translate"
        [formControlName]="'selectedDate'"></date-input-ctrl>

    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>